export function buildMerchantOptions(hotelGroups, currentMerchantId) {
  return (hotelGroups || []).reduce((options, group) => {
    if (group == null || group.id == null) {
      return options
    }

    if (Number(group.id) === Number(currentMerchantId)) {
      return options
    }

    if (Number(group.id) <= 0) {
      return options
    }

    if (group.name === 'Independently Managed Hotels') {
      return options
    }

    return {
      ...options,
      [String(group.id)]: group.name
    }
  }, {})
}
